import * as BaseApi from "api/Base.api";
import { IDiary } from "api/interfaces/profile.interface";
import { IPagination } from "api/interfaces/common.interface";



//* 홈 정보 조회    
//  2025.03.04
//  희문
//* Params
//  none
export const fetchHomeInfo = async () => {
    const url = "/koach/v2/home";
    return await BaseApi.get(url);
};

export interface IFetchHomeStudentDiaryResponse {
    diaryList: IDiary[];
    pagination: IPagination;
}

//* 홈 지망생 다이어리 목록 조회
// 2025.08.14
// 희문
//* Params
//  none
export const fetchHomeStudentDiary = async (params: any): Promise<IFetchHomeStudentDiaryResponse> => {
    const url = "/koach/v2/home/student-diary";
    return await BaseApi.get(url, params);
};

export interface IFetchFollowerListResponse {
    studentList: Array<{
        id: number;
        userId: string;
        nickname?: string;
        profileImageUrl?: string;
        profileImage?: any;
    }>;
}

//* 코치의 팔로워 목록 조회 (지망생 목록)
// 2025.01.27
// 희문
//* Params
//  limit?: number
export const fetchFollowerList = async (limit?: number): Promise<IFetchFollowerListResponse> => {
    const url = `/koach/v2/home/follower${limit ? `?limit=${limit}` : ''}`;
    return await BaseApi.get(url);
};